import { BaseRequestModel } from "./BaseModel/BaseRequestModel";

export class getpublicportalfaqsbyid_webportal extends BaseRequestModel{
    ID:number
}